// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"06b54d5b","488":"507c0173"}[chunkId] + ".chunk.js";
};